import {QuickStat} from '../../../types/college';
import {Formik} from 'formik';
import Modal from '../../../../shared/components/modal';
import Table from '../../../components/SimpleTable';
import classnames from 'classnames';
import styles from './styles.module.scss';
import FormikIconPicker from '../../../components/FormikIconPicker';
import FormikTextField from '../../../components/FormikTextField';
import React from 'react';

interface EditCustomQuickStatModalProps {
  customQuickStat: QuickStat;
  updateCustomQuickStat: (values: Partial<QuickStat>) => void;
  onClose: () => void;
  removeCustomQuickStat: () => void;
}
export const EditCustomQuickStatModal = ({
  customQuickStat,
  updateCustomQuickStat,
  onClose,
  removeCustomQuickStat,
}: EditCustomQuickStatModalProps): React.ReactElement => (
  <Formik
    initialValues={customQuickStat}
    onSubmit={(values): void => {
      if (values.label && values.value) {
        updateCustomQuickStat(values);
      } else {
        removeCustomQuickStat();
      }
      onClose();
    }}
  >
    {({handleSubmit, values}): React.ReactElement => {
      // ensures we aren't saving empty quick stats
      const closeModal = (): void => {
        onClose();
        if (!values.label || !values.value) {
          removeCustomQuickStat();
        }
      };

      return (
        <Modal show onClose={closeModal}>
          <Modal.TextHeader onClose={closeModal}>Editing Custom Quick Stat</Modal.TextHeader>
          <Modal.Body>
            <>
              <Table>
                <thead>
                  <tr>
                    <th className={classnames(styles.cellPadding, styles.headerCell)}>Icon</th>
                    <th className={classnames(styles.cellPadding, styles.headerCell)}>Label</th>
                    <th className={classnames(styles.cellPadding, styles.headerCell)}>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className={styles.cellPadding}>
                      <FormikIconPicker name="iconType" />
                    </th>
                    <th className={styles.cellPadding}>
                      <FormikTextField name="label" />
                    </th>
                    <th className={styles.cellPadding}>
                      <FormikTextField name="value" />
                    </th>
                  </tr>
                </tbody>
              </Table>
            </>
          </Modal.Body>
          <Modal.Footer
            primaryButton={{
              text: 'Save',
              onClick: handleSubmit,
            }}
          />
        </Modal>
      );
    }}
  </Formik>
);
